import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: constants.wholeHouse.bom.search.sortFields,
	columnFields: constants.wholeHouse.bom.search.columnFields,
	standardFilterFields: constants.wholeHouse.bom.search.filterFields,
	dateFilterFields: [],
	stageStatusFilterFields: [],
	booleanFilterFields: [] as const,
	groupingFields: constants.wholeHouse.bom.search.groupingFields,
});
